import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { PHONE_DISPLAY, PHONE_TEL } from "@/constants/neco";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled
          ? "bg-[#121110]/90 backdrop-blur-xl border-b border-[#D4AF37]/20"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <a href="#top" data-testid={HOME.navLogo} className="flex items-center gap-3">
          <img src="/images/neco-logo.png" alt="Neco Plaza logosu" className="h-12 w-12 md:h-14 md:w-14 object-contain" />
          <span className="flex flex-col leading-none">
            <span className="font-display text-xl md:text-2xl tracking-wide text-[#F5F5F0]">
              Neco <span className="text-[#D4AF37]">Plaza</span>
            </span>
            <span className="text-[9px] uppercase tracking-[0.35em] text-[#B3B0A8] mt-1">
              1973'ten beri · Samsun
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9 text-xs uppercase tracking-[0.2em] text-[#B3B0A8]">
          <a href="#salonlar" className="hover:text-[#E5C783] transition-colors duration-300">Salonlar</a>
          <a href="#organizasyonlar" className="hover:text-[#E5C783] transition-colors duration-300">Organizasyonlar</a>
          <a href="#ikram" className="hover:text-[#E5C783] transition-colors duration-300">İkram &amp; Menü</a>
          <a href="#iletisim" className="hover:text-[#E5C783] transition-colors duration-300">İletişim</a>
        </nav>

        <div className="flex items-center gap-4">
          <a
            href={PHONE_TEL}
            data-testid={HOME.navPhoneLink}
            className="hidden md:flex items-center gap-2 text-sm text-[#F5F5F0] hover:text-[#E5C783] transition-colors duration-300"
          >
            <Phone size={15} strokeWidth={1.5} />
            <span className="tracking-wider">{PHONE_DISPLAY}</span>
          </a>
          <a
            href="#rezervasyon"
            data-testid={HOME.navReservationButton}
            className="border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#121110] transition-colors duration-300 px-6 py-2.5 text-xs uppercase tracking-[0.2em]"
          >
            Rezervasyon
          </a>
        </div>
      </div>
    </header>
  );
};
